import { render } from "./CustomisationTabButton.vue?vue&type=template&id=56df3382&scoped=true"
import script from "./CustomisationTabButton.vue?vue&type=script&lang=js"
export * from "./CustomisationTabButton.vue?vue&type=script&lang=js"

import "./CustomisationTabButton.vue?vue&type=style&index=0&id=56df3382&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56df3382"]])

export default __exports__